<template>
  <div>
    <div class="header">
      <h1>{{ detail.name }}</h1>
      <div class="header-content">
        <div class="left">
          <div class="item-box" style="margin-bottom: 30px">
            <div class="item">资源个数：{{ detail.count }}</div>
            <div class="item">创建日期：{{ detail.createTime }}</div>
            <div class="item">关联机构：{{ detail.usageCount || 0 }}个</div>
          </div>
          <div class="item-box">
            <div class="item">
              文件大小：
              {{ detail.size || '--' }}
            </div>
            <div class="item">简介：{{ detail.description || '--' }}</div>
            <div class="item">备注：{{ detail.remark || '--' }}</div>
          </div>
          <div class="item-box" style="margin-bottom: 30px"></div>
        </div>
      </div>
    </div>
    <a-card class="table">
      <a-form :labelCol="{ span: 6 }" :wrapperCol="{ span: 16 }">
        <a-row>
          <a-col :span="6">
            <a-form-item label="资源标题">
              <a-input v-model.trim="searchForm.name" v-trim placeholder="请输入资源标题" :maxLength="20" allowClear />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item label="类型">
              <a-select v-model="searchForm.fileType" placeholder="请选择类型" allowClear @change="(e) => (searchForm.fileType = e)">
                <a-select-option value="1">文档</a-select-option>
                <!-- <a-select-option value="2">PPT</a-select-option> -->
                <a-select-option value="4">视频</a-select-option>
                <a-select-option value="2">图片</a-select-option>
                <a-select-option value="3">音频</a-select-option>
                <a-select-option value="0">文件夹</a-select-option>
                <a-select-option value="5">压缩文件</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :wrapperCol="{ span: 24 }">
              <a-col :span="12">
                <a-button type="primary" @click="getPageList(1)">查询</a-button>
                <a-button style="margin-left: 8px" @click="resetSearch">重置</a-button>
              </a-col>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <a-row v-if="breadcrumbList.length > 1" style="margin-bottom: 10px">
        <a-breadcrumb>
          <a-breadcrumb-item v-for="(item, index) in breadcrumbList" :key="item.id">
            <span @click="handleBreadcrumb(index, item)" class="link"> {{ item.name }}</span>
          </a-breadcrumb-item>
        </a-breadcrumb>
      </a-row>
      <a-row type="flex">
        <!-- <a-col :span="3" style="min-width: 210px; width: 210px">
          <a-tree :selectedKeys.sync="searchForm.categoryId" :tree-data="folderList" :replace-fields="replaceFields" @select="selectFolder">
            <template slot="custom" slot-scope="data">
              <span>{{ data.name }}</span>
            </template>
          </a-tree>
          <div v-if="!folderList.length" class="empty">暂无数据</div>
        </a-col> -->
        <a-col :span="24" style="flex: 1">
          <a-table :columns="gradeColumns" :pagination="gradeTableRelevant.tablePagination" row-key="id" :loading="gradeTableRelevant.tableLoading" :data-source="gradeTableRelevant.tableDataSource">
            <div slot="name" class="table-name" slot-scope="text">
              <img :src="$getFileType(text.fileType).icon" style="width: 15px; height: 15px" />
              <a @click="nextFolder(text, true)" v-if="!text.fileType">{{ text.name }} </a>
              <span v-else :title="text.name">{{ text.name + suffix(text.fileName, 1) }}</span>
            </div>
            <div slot="downloadAuthority" slot-scope="text">
              <span>{{ text.downloadAuthority ? '启用' : '禁用' }}</span>
              <!-- <a-switch :checked="text.downloadAuthority" :disabled="text.folderType === 2" @change="changeDownload($event, text)"></a-switch> -->
            </div>
            <div slot="size" slot-scope="text">
              {{ text.size > 1024 * 1024 ? (text.size / (1024 * 1024)).toFixed(2) + 'M' : text.size / 1024 < 1 ? (text.size ? text.size + 'B' : '--') : (text.size / 1024).toFixed(2) + 'KB' }}
            </div>
            <div slot="fileType" slot-scope="text">
              {{ searchFileType[text.fileType] }}
              {{ text.fileType === 1 && text.fileName ? `（${suffix(text.fileName)}）` : '' }}
            </div>
            <div slot="action" slot-scope="text">
              <a v-if="![5, 0].includes(text.fileType)" :class="text.fileType === 5 ? 'disabled-btn' : ''" style="margin-right: 10px" href="javaScript:;" @click="view(text)"> 查看</a>
              <a v-if="text.fileType > 0" v-permission="`Tdetail.Download`" style="margin-right: 10px" href="javaScript:;" @click="download(text)">下载</a>
            </div>
          </a-table>
        </a-col>
      </a-row>
    </a-card>
    <a-modal v-model="preview.visible" :centered="true" title="预览" width="800px" :footer="null" destroyOnClose>
      <a-spin :spinning="preview.loading">
        <div v-if="preview.info.fileType === 3" style="padding: 30px">
          <my-audio :src="preview.src | filterUrl"></my-audio>
        </div>
        <div id="J_prismPlayer" style="height: 500px" v-if="preview.info.fileType === 4"></div>
        <div v-if="preview.info.fileType === 2" style="height: 500px">
          <img :src="preview.src | filterUrl" alt="" style="width: 100%; height: 500px; object-fit: cover" />
        </div>
      </a-spin>
    </a-modal>
  </div>
</template>
<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import $Bus from '@/pages/projectImpl/js/eventBus'
import PageHeader from '@/components/page/header/PageHeader'
import MyAudio from '@/components/audio/index.vue'
import Api from '@/requests/apis'

const routes = [
  '首页',
  '内容中心',
  {
    path: '/content/TResources',
    breadcrumbName: '教学资源',
    meta: {
      title: '教学资源',
      getTitle: true,
    },
  },
  {
    path: '/content/addTResources',
    breadcrumbName: '资源包详情',
    meta: {
      title: '资源包详情',
      getTitle: true,
    },
  },
]
export default {
  components: { PageHeader, MyAudio },
  data() {
    return {
      searchForm: {},
      visible: false,
      detail: {},
      preview: {
        info: {},
      },
      moveVisible: false,
      movecategoryId: undefined,
      replaceFields: {
        key: 'id',
        title: 'name',
        children: 'children',
      },
      breadcrumbList: [
        {
          name: '教学资源',
          id: undefined,
        },
      ],
      searchFileType: ['文件夹', '文档 ', '图片', '音频', '视频', '压缩文件'],
      gradeTableRelevant: tableRelevant.call(this),
      gradeColumns: [
        {
          title: '资源标题',
          scopedSlots: { customRender: 'name' },
        },
        {
          title: '源文件名称',
          dataIndex: 'sourceFileName',
        },
        {
          title: '大小',
          scopedSlots: { customRender: 'size' },
        },
        {
          title: '类型',
          scopedSlots: { customRender: 'fileType' },
        },
        {
          title: '下载权限',
          scopedSlots: { customRender: 'downloadAuthority' },
        },
        {
          title: '操作',
          scopedSlots: { customRender: 'action' },
        },
      ],
      selectedRowKeys: [],
      selectRow: [],
      searchForm: {
        fileType: undefined,
        name: undefined,
      },
      folderForm: this.$form.createForm(this, { name: 'coordinated' }),
      sourceForm: this.$form.createForm(this, { name: 'coordinated' }),
      visibleFolder: false,
      visibleSource: false,
      confirmLoading: false,
      folderList: [],
    }
  },
  created() {
    $Bus.$emit('pageHeaderBreadcrumb', routes)
    this.$store.commit('setting/setShowPageTitle', false)
    if (this.$route.query.id) {
      // this.getDetail(this.$route.query.id)
      const params = JSON.parse(this.$route.query.params)
      this.detail = params
      this.getPageList(1)
      this.getTreeMenu()
      this.$http.CourseService.ResourcePackageUsages({ packageIds: [this.$route.query.id] }).then(({ data }) => {
        this.detail = { ...this.detail, ...(data[0] || {}) }
      })
    }
  },
  beforeDestroy() {
    this.$store.commit('setting/setShowPageTitle', true)
  },
  methods: {
    resetSearch() {
      this.searchForm.name = undefined
      this.searchForm.fileType = undefined
      this.getPageList(1)
    },
    getTreeMenu() {
      function initTree(data = []) {
        return data.map((v) => {
          v.scopedSlots = { title: 'custom' }
          if (v.children) {
            v.children = initTree(v.children)
          }
          return v
        })
      }
      this.$http.CourseResource.getTreeMenu({ id: this.$route.query.id }).then((res) => {
        this.folderList = data.data.filter((v) => v.id !== -1)
        this.folderList.unshift({
          name: '全部',
          id: -2,
          children: [],
        })
        this.folderList = initTree(this.folderList)
      })
    },
    changeDownload(e, reocrd) {
      const fm = new FormData()
      fm.append('ids', reocrd.id)
      fm.append('isDownload', e)
      this.$http.CourseResource.changeDownload(fm).then((res) => {
        this.$message.success('操作成功')
        this.getPageList(1)
      })
    },
    nextFolder(record, flag) {
      this.breadcrumbList.push({
        id: record.id,
        name: record.name,
        categoryId: record.categoryId,
        folderType: record.folderType,
      })
      this.searchForm.name = undefined
      this.searchForm.fileType = undefined
      this.searchForm = { ...this.searchForm }
      flag && this.getPageList(1)
    },
    handleBreadcrumb(index, item) {
      this.breadcrumbList = this.breadcrumbList.slice(0, index + 1)
      if (this.breadcrumbList.length === 1) {
        this.searchForm.categoryId = []
      }
      this.getPageList(1)
    },
    getByFold(id) {
      const stack = [...this.folderList]
      while (stack.length) {
        const item = stack.pop()
        if (item.id == id) {
          return item
        }
        if (item.children) {
          item.children.forEach((v) => stack.push(v))
        }
      }
    },
    selectFolder(e = []) {
      if (!e[0] || e[0] < 0) {
        this.breadcrumbList = this.breadcrumbList.slice(0, 1)
        this.getPageList(1)
      } else {
        const item = this.getByFold(e[0])
        if (item) {
          this.breadcrumbList = this.breadcrumbList.slice(0, 1)
          if (item.parentId) {
            const item2 = this.folderList.find((v) => v.fileResourceId == item.parentId)
            if (item2) {
              this.nextFolder(item2)
            }
          }
          this.nextFolder(item, true)
        } else {
          this.getPageList(1)
        }
      }
    },
    getPageList(pageIndex) {
      const params = {
        pageIndex: pageIndex || this.gradeTableRelevant.tablePagination.current,
        pageSize: this.gradeTableRelevant.tablePagination.pageSize,
        ...this.searchForm,
        resourcePackageId: this.$route.query.id,
      }
      if (params.name || params.fileType !== undefined) {
        this.breadcrumbList = this.breadcrumbList.slice(0, 1)
        this.searchForm.categoryId = []
      }
      if (this.breadcrumbList.length > 1) {
        const item = this.breadcrumbList.slice(-1)[0]
        params.categoryId = item.id
        this.searchForm.categoryId = [item.id]
        // params.folderType = item.folderType
      } else {
        params.categoryId = (this.searchForm.categoryId || [])[0]
      }

      if (params.categoryId < 0) {
        params.categoryId = undefined
      }
      this.gradeTableRelevant.tableLoading = true
      this.$http.CourseResource.getPagelistPackage(params).then((res) => {
        this.gradeTableRelevant.tableLoading = false
        this.gradeTableRelevant.tableDataSource = res.data.items.map((m) => ({ ...m, size: m.fileSize }))
        this.gradeTableRelevant.tablePagination.total = res.data.totalCount
        this.gradeTableRelevant.tablePagination.current = res.data.pageIndex
      })
    },
    suffix(str, point) {
      str = str || ''
      if (point) {
        return str.substring(str.lastIndexOf('.')).toLowerCase()
      }
      return str.substring(str.lastIndexOf('.') + 1).toLowerCase()
    },
    view(val) {
      this.$message.destroy()
      if (val.fileType === 5) {
        this.$message.error('文件不支持预览')
        return
      }
      if (!val.fileType) {
        this.nextFolder(val, true)
        return
      }
      this.preview = {
        visible: true,
        loading: false,
        info: val,
        src: process.env.VUE_APP_API_BASE_URL + Api.Content.downloadFileStream + '?id=' + val.fileResourceId,
      }
      if (val.fileType === 4) {
        const params = { id: val.fileResourceId }
        this.$http.FileResource.getVideoPlayAuth(params)
          .then((res) => {
            const { data, status, message } = res
              this.$nextTick(() => {
                new Aliplayer(
                  {
                    id: 'J_prismPlayer',
                    width: '100%',
                    height: '500px',
                    autoplay: true,
                    vid: data.videoId, //播放方式二必选参数。可以通过点播控制台（媒资库>音/视频路径）查询。示例：1e067a2831b641db90d570b6480f****。
                    playauth: data.playAuth, //播放方式二必选参数。参数值可通过调用GetVideoPlayAuth接口获取。
                  },
                  (player) => {
                    console.log('The player is created.')
                  }
                )
              })
            
          })
          .catch((e) => {
            this.preview.visible = false
          })
      }
      if (val.fileType === 2) {
        this.preview.loading = true
        const xhr = new XMLHttpRequest()
        xhr.open('GET', this.preview.src, true)
        xhr.responseType = 'blob'
        xhr.setRequestHeader('Authorization', 'Bearer ' + this.$store.getters['account/token']())
        xhr.send(null)
        xhr.onload = () => {
          this.preview.src = window.URL.createObjectURL(xhr.response)
          this.preview.loading = false
        }
      }
      if (val.fileType === 1) {
        this.preview.visible = false
        const Params = {
          materialId: val.fileResourceId,
        }
        this.$http.resourcesList.GeneratePresignedUri(Params).then((res) => {
          const { data } = res
          window.open(data)
        })
      }
    },
    download(val) {
      const path = process.env.VUE_APP_API_BASE_URL + Api.Content.downloadFileStream + '?id=' + val.fileResourceId
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = path
      document.body.appendChild(link)
      link.click() //执行下载
      URL.revokeObjectURL(link.href)
      document.body.removeChild(link)
    },
  },
}
</script>
<style lang="less" scoped>
.header {
  background: #fff;
  width: calc(100% + 48px);
  margin-top: -24px;
  margin-left: -24px;
  margin-bottom: 24px;
  padding: 0 24px;
  padding-bottom: 20px;
  h1 {
    font-weight: 500;
    font-size: 20px;
  }
  .header-content {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
    color: #333;
    .left {
      font-size: 16px;
      // font-weight: 600;
      .item-box {
        display: flex;
        .item {
          width: 300px;
        }
      }
    }
  }
}
.table-name {
  display: flex;
  align-items: center;
  img {
    margin-right: 4px;
  }
}
.link {
  cursor: pointer;
}
.empty {
  color: #666;
  text-align: center;
}
</style>
